import {FC} from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'
import {CleanerLayout} from '../pages/cleaner/CleanerLayout'
import {CleanerDashboard} from '../pages/cleaner/CleanerDashboard'
import {CleanerQueuePage} from '../pages/cleaner/CleanerQueuePage'
import {CleanerLogVisitPage} from '../pages/cleaner/CleanerLogVisitPage'
import {CleanerEarningsPage} from '../pages/cleaner/CleanerEarningsPage'
import {CleanerPaymentsPage} from '../pages/cleaner/CleanerPaymentsPage'
import {CleanerDoorCodesPage} from '../pages/cleaner/CleanerDoorCodesPage'

/**
 * Housekeeping (CLEANER) routes — an overview with stat cards plus a list page
 * behind each card (queue, earnings, payments, door codes). Any other path
 * redirects to the overview; cleaners never see the admin or renter chrome.
 */
const CleanerRoutes: FC = () => (
  <Routes>
    <Route path='housekeeping' element={<CleanerLayout />}>
      <Route index element={<CleanerDashboard />} />
      <Route path='queue' element={<CleanerQueuePage />} />
      <Route path='log-visit' element={<CleanerLogVisitPage />} />
      <Route path='earnings' element={<CleanerEarningsPage />} />
      <Route path='payments' element={<CleanerPaymentsPage />} />
      <Route path='door-codes' element={<CleanerDoorCodesPage />} />
    </Route>
    <Route path='*' element={<Navigate to='/housekeeping' replace />} />
  </Routes>
)

export {CleanerRoutes}
